<template>
  <v-col>
    <div class="display-1">Start a Feed</div>
    <breast side="L" @click="start('L')"></breast>
    <breast side="R" @click="start('R')"></breast>
  </v-col>
</template>

<script>
import Breast from './Breast';
import {mapActions} from 'vuex';

export default {
  name: 'StartFeed',
  components: {Breast},
  methods: {
    ...mapActions('feeds', [
      'startFeed'
    ]),
    start(side) {
      this.startFeed(side).catch(err => this.$logger.error(err));
    }
  }
}
</script>

<style scoped>

</style>
